import { render, staticRenderFns } from "./sys-open-index.vue?vue&type=template&id=20301c22&scoped=true"
import script from "./sys-open-index.vue?vue&type=script&lang=js"
export * from "./sys-open-index.vue?vue&type=script&lang=js"
import style0 from "./sys-open-index.vue?vue&type=style&index=0&id=20301c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20301c22",
  null
  
)

export default component.exports